module.exports = __webpack_public_path__ + "6680615d766be600b89f5fe3c578755a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-21.png
// module id = 2496
// module chunks = 0